import { render, staticRenderFns } from "./construcMe.vue?vue&type=template&id=60ca3cea"
import script from "./construcMe.vue?vue&type=script&lang=js"
export * from "./construcMe.vue?vue&type=script&lang=js"
import style0 from "./construcMe.vue?vue&type=style&index=0&id=60ca3cea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports